module.exports = __webpack_public_path__ + "static/media/dhanashree_mahadeo.f02120bf.jpg";